'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KeypadDirective = KeypadDirective;

var _keypad = require('./keypad.controller');

var _keypad2 = require('./templates/keypad.html');

var _keypad3 = _interopRequireDefault(_keypad2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a keypad
 *
 * @param {String} numberModel : '77043'
 * @param {Integer} maxLength : 10
 * @return {Element} <div.keypad>
 */
function KeypadDirective() {
    'ngInject';

    var directive = {
        restrict: 'E',
        replace: true,
        scope: {},
        bindToController: {
            bcNumberModel: '=',
            bcMaxLength: '@',
            bcLeftButton: '@',
            bcRightButton: '@',
            bcLeftButtonMethod: '&',
            bcRightButtonMethod: '&',
            bcEmptyBackspaceMethod: '&'
        },
        templateUrl: _keypad3.default,
        controller: _keypad.KeypadController,
        controllerAs: 'vm'
    };

    return directive;
}


/** WEBPACK FOOTER **
 ** ./src/keypad.directive.js
 **/